import React, { useEffect, useState } from 'react'
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button, CircularProgress, Typography,
} from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { getCadeia } from 'store/modules/api/operacoes-lbc/operacoes-lbc.api'
import CadeiaNo from './cadeia-no'

const CadeiaDialog = ({ tituloId, onFechar }) => {
  const { t } = useTranslation()
  const [arvore, setArvore] = useState(null)
  const [loading, setLoading] = useState(true)
  const [erro, setErro] = useState('')

  useEffect(() => {
    let ativo = true
    setLoading(true)
    getCadeia(tituloId)
      .then((r) => { if (ativo) setArvore(r) })
      .catch((e) => { if (ativo) setErro(e.message) })
      .finally(() => { if (ativo) setLoading(false) })
    return () => { ativo = false }
  }, [tituloId])

  return (
    <Dialog open fullWidth maxWidth="md" onClose={onFechar}>
      <DialogTitle>{t('operacoesLbc.cadeiaTitulo')}</DialogTitle>
      <DialogContent>
        {loading && <CircularProgress />}
        {!loading && erro && <Typography color="error" variant="body2">{erro}</Typography>}
        {!loading && !erro && arvore && <CadeiaNo no={arvore} tituloId={tituloId} />}
        {!loading && !erro && arvore && (arvore.filhos || []).length === 0 && (
          <Typography variant="caption" color="textSecondary">{t('operacoesLbc.semOperacoes')}</Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onFechar}>{t('inputs.cancelar')}</Button>
      </DialogActions>
    </Dialog>
  )
}

export default CadeiaDialog
